import {
  UseToastOptions,
  useClipboard,
  useToast,
  UseClipboardOptions,
} from "@chakra-ui/react";
import { useCallback } from "react";

type UseClipboardToastOptions = UseClipboardOptions & {
  value: string | undefined;
  toastOptions?: UseToastOptions;
};

/**
 * Wrapper around Chakra's useClipboard that optionally shows a toast after copying.
 */
export function useClipboardToast({
  value,
  toastOptions,
  ...clipboardOptions
}: UseClipboardToastOptions) {
  const clipboard = useClipboard(value ?? "", clipboardOptions);

  const toast = useToast();

  const onCopy = useCallback(() => {
    if (!value) {
      return;
    }

    clipboard.onCopy();

    if (toastOptions) {
      toast({
        title: "Copied",
        status: "success",
        variant: "subtle",
        duration: 1000,
        ...toastOptions,
      });
    }
  }, [value, clipboard, toast, toastOptions]);

  return {
    ...clipboard,
    onCopy,
  };
}
